export const slots = [
  { turn: "Manhã", start: "07:30", end: "08:20" },
  { turn: "Manhã", start: "08:20", end: "09:10" },
  { turn: "Manhã", start: "09:10", end: "10:00" },
  { turn: "Manhã", start: "10:10", end: "11:00" },
  { turn: "Manhã", start: "11:00", end: "11:50" },
  { turn: "Tarde", start: "13:30", end: "14:20" },
  { turn: "Tarde", start: "14:20", end: "15:10" },
  { turn: "Tarde", start: "15:10", end: "16:00" },
  { turn: "Tarde", start: "16:20", end: "17:10" },
  { turn: "Tarde", start: "17:10", end: "18:00" },
  { turn: "Noite", start: "18:30", end: "19:20" },
  { turn: "Noite", start: "19:20", end: "20:10" },
  { turn: "Noite", start: "20:20", end: "21:10" },
  { turn: "Noite", start: "21:10", end: "22:00" },
];

export const timeChoices = [...new Set(slots.flatMap((slot) => [slot.start, slot.end]))].sort();
export const dayNames = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
const monthNames = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

export function isoDate(value) {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function dateFromIso(value) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function weekStart(value = new Date()) {
  const result = new Date(value.getFullYear(), value.getMonth(), value.getDate());
  const weekday = result.getDay() || 7;
  result.setDate(result.getDate() - weekday + 1);
  return result;
}

export function addDays(value, amount) {
  const result = new Date(value.getFullYear(), value.getMonth(), value.getDate());
  result.setDate(result.getDate() + amount);
  return result;
}

export function formatShortDate(value) {
  return `${String(value.getDate()).padStart(2, "0")}/${String(value.getMonth() + 1).padStart(2, "0")}`;
}

export function formatWeekPeriod(monday) {
  const sunday = addDays(monday, 6);
  if (monday.getMonth() === sunday.getMonth()) {
    return `${monday.getDate()} a ${sunday.getDate()} de ${monthNames[sunday.getMonth()]} de ${sunday.getFullYear()}`;
  }
  return `${monday.getDate()} de ${monthNames[monday.getMonth()]} a ${sunday.getDate()} de ${monthNames[sunday.getMonth()]} de ${sunday.getFullYear()}`;
}

const classPattern = /^([A-Z]{2,5}\d{3,5})\s*-\s*(.+)$/i;

export function cleanSubject(rawTitle = "") {
  return rawTitle
    .replace(/^\s*-\d{2}:\d{2}\.\s*/, "")
    .replace(/\s*\[\d+\]\s*$/, "")
    .replace(/\s*\((?:19|20)\d{3}\)\s*$/, "")
    .replace(/\s+/g, " ")
    .replace(/^[ .-]+|[ .-]+$/g, "")
    .trim();
}

export function isRegularClass(rawTitle = "") {
  return classPattern.test(cleanSubject(rawTitle));
}

export function displayText(event, roomSigla) {
  const subject = cleanSubject(event.title);
  const match = subject.match(classPattern);
  if (match) return `${match[1].toUpperCase()} - ${match[2].trim()}`;
  if (["AUD", "ANF"].includes(roomSigla) && subject) return subject;
  return formatShortDate(dateFromIso(event.start_date));
}

export function eventKind(event) {
  return isRegularClass(event.title) ? "class" : "reservation";
}

function localDateTime(dateText, timeText) {
  const date = dateFromIso(dateText);
  const [hours, minutes] = timeText.split(":").map(Number);
  date.setHours(hours, minutes, 0, 0);
  return date;
}

export function eventOverlaps(event, startDate, startTime, endTime) {
  const start = localDateTime(isoDate(startDate), startTime);
  const end = localDateTime(isoDate(startDate), endTime);
  const eventStart = localDateTime(event.start_date, event.start_time);
  const eventEnd = localDateTime(event.end_date || event.start_date, event.end_time || event.start_time);
  return eventStart < end && eventEnd > start;
}

export function eventsForSlot(events, slotDate, slot) {
  return events.filter((event) => eventOverlaps(event, slotDate, slot.start, slot.end));
}

export function slotSpanForEvent(event, day) {
  const indexes = slots
    .map((slot, index) => (eventOverlaps(event, day, slot.start, slot.end) ? index : -1))
    .filter((index) => index >= 0);
  if (!indexes.length) return null;
  return { start: indexes[0], span: indexes[indexes.length - 1] - indexes[0] + 1 };
}

export function availableRooms(rooms, eventsByRoom, queryDate, startTime, endTime, roomType, minimumCapacity) {
  if (endTime <= startTime) throw new Error("O horário final deve ser posterior ao horário inicial.");
  return rooms.filter((room) => {
    if (roomType === "Sala de aula" && room.tipo !== "Sala de aula") return false;
    if (roomType === "Auditório" && !["AUD", "ANF"].includes(room.sigla)) return false;
    if (minimumCapacity && Number(room.capacidade || 0) < minimumCapacity) return false;
    return !(eventsByRoom[room.sigla] || []).some((event) => eventOverlaps(event, queryDate, startTime, endTime));
  });
}
